import React from "react";
import styled, { keyframes } from "styled-components";
import atchezaMarkerIcon from "../assets/images/atcheza-marker.png";

const bounce = keyframes`
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
`;

const Container = styled.div`
  display: flex;
  gap: 1rem;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const Dot = styled.span`
  width: 12px;
  height: 12px;
  background-color: var(--color-primary);
  border-radius: 50%;
  animation: ${bounce} 0.6s infinite ease-in-out;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

const Avatar = styled.div`
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #0c798b;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const AvatarIcon = styled.img`
  width: 70%;
  height: auto;
  display: block;
`;

const LoadingAnswer = () => {
  return (
    <Container>
      <Avatar>
        <AvatarIcon src={atchezaMarkerIcon} alt="" loading="lazy" />
      </Avatar>
      <LoaderContainer>
        <Dot />
        <Dot />
        <Dot />
      </LoaderContainer>
    </Container>
  );
};

export default LoadingAnswer;
